import InputField from './InputField';

export { type InputFieldProps } from './InputField';
export default InputField;
